import { InterestVariableEnum } from '../../../@shared/domain/enums/InterestVariable.enum'

/**
 * Container do blob storage onde o walter grava os PNGs de residuo do
 * processamento smart: <container>/<customerId>/<arquivo>.
 *
 * E o MESMO container dos rasters de resultado -- ver buildRasterBlobUrl em
 * DashboardAgilityRaster.viewmodel.ts, que repete esta string. Os graficos nao
 * ficam num container proprio.
 */
const RESIDUES_CHART_CONTAINER = 'rasters-resultado-processamento'

const SUBSCRIPT_DIGITS = '₀₁₂₃₄₅₆₇₈₉'

const toSubscript = (value: number): string =>
	String(value)
		.split('')
		.map((digit) => SUBSCRIPT_DIGITS[Number(digit)])
		.join('')

/**
 * Uma linha de auditoria do processamento smart: o modelo ajustado para uma
 * variavel de interesse, seus coeficientes e as metricas de aderencia.
 */
export class SmartProcessingAudit {
	constructor(
		readonly interestVariable: InterestVariableEnum,
		readonly adjustedModelLatex: string,
		readonly adjustedModelCoefficients: number[],
		readonly adjustedR2: number,
		readonly error: number,
		readonly errorPercentage: number,
		readonly residuesChartIdentifier: string,
	) {}

	/**
	 * O primeiro coeficiente e o intercepto, entao a numeracao comeca em beta
	 * zero. Difere do AboutModel dos modelos hipsometricos, que rotula a partir
	 * de beta um -- nao da para reaproveitar os rotulos de la.
	 */
	get coefficientLabels(): string[] {
		return this.adjustedModelCoefficients.map((_, index) => `β${toSubscript(index)}`)
	}

	get hasResiduesChart(): boolean {
		return this.residuesChartIdentifier.length > 0
	}

	get residuesChartUrl(): string {
		if (!this.hasResiduesChart) return ''

		const customerId = localStorage.getItem('customerId')

		return `${process.env.VUE_APP_STORAGE_BASE_URL}/${RESIDUES_CHART_CONTAINER}/${customerId}/${this.residuesChartIdentifier}`
	}

	get formattedAdjustedR2(): string {
		return this.adjustedR2.toFixed(3)
	}

	get formattedError(): string {
		return this.error.toFixed(3)
	}

	get formattedErrorPercentage(): string {
		return this.errorPercentage.toFixed(3)
	}
}
